
import { Component, Vue, Prop } from 'vue-property-decorator';
import {justiceNames} from '@/components/utils/JusticeName';

@Component
export default class AddJudgeForm extends Vue {        

    @Prop({required: true})
    formData!: {name:string, other:string};

    @Prop({required: true})
    index!: number;

    @Prop({required: true})
    isCreateJudge!: boolean;   
    
    justiceNameOptions = [];
    created(){
        this.justiceNameOptions = justiceNames
    }
    
    name = '';
    otherName = ''
    nameState = true;
    otherNameState = null;

    originalName = '';    
    
    showCancelWarning = false;

    addButtonText = 'Add';
    dataReady = false;
    
    mounted()
    { 
        this.dataReady = false;
        this.clearSelections();
        if(!this.isCreateJudge) {
            this.extractFormInfo();
            this.addButtonText = 'Save';
        } else {
            this.addButtonText = 'Add';
        }
        
        this.dataReady = true;              
    }

    public extractFormInfo(){
        this.originalName = this.name = this.formData.name; 
        this.otherName = this.formData.other;                  
    }

    public saveForm(){
            
        this.nameState = this.name != "";
        this.otherNameState = this.name=='Other' && this.otherName==''? false : null         
        // console.log(this.name)
        // console.log(this.isCreateJudge) 
        // console.log(this.index)      
        const othername = this.name=='Other'? this.otherName :''

        if (this.nameState && this.otherNameState==null){
            const judgeName = this.name;            
            this.$emit('submit', this.isCreateJudge, judgeName, this.index, othername);
        }            
    }

    public closeForm(){
        if(this.isChanged())
            this.showCancelWarning = true;
        else
            this.confirmedCloseForm();
    }

    public isChanged(){
        if(this.isCreateJudge){
            if(this.name.length) return true;
            return false;
        } else {

            if ( this.originalName != this.name ) {
                    return true;
                } else {
                    return false;
                }                
        }
    }

    public confirmedCloseForm(){           
        this.clearSelections();
        this.$emit('cancel');
    }

    public clearSelections(){
        this.name = '';
        this.nameState = true; 
    }
    
}
